
import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
// import Navbar from './Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import SignUp from './UIElements/authentication/SignUp'
import ForgotPassword from './UIElements/authentication/ForgotPassword';
import ValidateCode from './UIElements/authentication/ValidateCode';
import SignIn from './UIElements/authentication/SignIn';
import VerifyEmail from './UIElements/authentication/VerifyEmail';
import UpdatePassword from './UIElements/Settings/UpdatePassword';
import Profile from './UIElements/Settings/Profile';
import Settings from './UIElements/Settings/Setting';
import DialPad from './UIElements/Settings/DialPad';
import Datasets from './UIElements/Datasets/Dataset';
import DatasetsMobileUI from './UIElements/Datasets/DatasetsMobileUI';
import SettingsMobile from './UIElements/Settings/SettingsMobile';
import Home from './UIElements/Home/Home';
import Logs from './UIElements/Logs/Logs';
import LogsMobileUI from './UIElements/Logs/logsMobileUI'
import Users from './UIElements/Users/Users';
import Navbar from './UIElements/Navbar/Navbar';
import NavbarMobileUI from './UIElements/Navbar/NavbarMobileUI';
import './UIElements/Navbar/NavbarMobile.css';
import UsersMobileUI from './UIElements/Users/UsersMobileUI';
import ProfileMobile from './UIElements/Settings/ProfileMobile';
import UpdatePasswordMobile from './UIElements/Settings/UpdatePasswordMobile';
import AccessDenied from './UIElements/AccessDenied/AccessDenied';
import HomeMobileUI from './UIElements/Home/HomeMobileUI';
import Agencies from './UIElements/Agencies/agencyList';
import AddAgency from './UIElements/Agencies/addAgency';
import RequestSentDetails from './UIElements/RequestSentDetails/requestSentDetails';
import Ck_Dictionary from './UIElements/Ck_Dictionary/Ck_Dictionary';
import Ck_Schemas from './UIElements/Ck_Schemas/Ck_Schemas';
import Edit from './UIElements/Ck_Dictionary/Edit';
import AddSchema from "./UIElements/Ck_Schemas/AddSchema/AddSchema";
import RequestDetail from './UIElements/RequestSentDetails/RequestDetail';
import Docket_ListUI from "./UIElements/DocketDetails/Docket_ListUI";
import TicketHistory from './UIElements/RequestSentDetails/AgenctTicketHistory/ticketHistory';
import TicketDetails from './UIElements/RequestSentDetails/AgenctTicketHistory/ticketDetails';
import GlobalCCP from './UIElements/InboundCalls/GlobalCCP';
import CallHistory from './UIElements/Call_History/Call_History';
import AgencyDetailPage from './UIElements/AgencyDetailPage/AgencyDetailPage';
import RequestOpra from './UIElements/RequestOpra/Requestopra';
import FileUploadPage from './UIElements/FileUploadPage/fileUploadPage';
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });
  const [username, setUsername] = useState('');
  const location = useLocation();
  const callAccess = localStorage.getItem("callAccess");
  const UserStatus = localStorage.getItem("UserStatus");
  const navigate = useNavigate();
  console.log('testing log', UserStatus);
  const [isMobile, setIsMobile] = useState(false);


  // useEffect(() => {
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   // Check if the user is on a mobile device
  //   const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  //   setIsMobile(isMobileDevice);
  // }, []);

  useEffect(() => {
    const detectMobileDevice = () => {
      const userAgent = typeof window !== "undefined" ? navigator.userAgent : "";
      return /Mobi|Android|iPhone|iPad/i.test(userAgent);
    };

    // Function to check screen width
    const handleResize = () => {
      setIsMobile(detectMobileDevice() || window.innerWidth <= 768); // Set based on device or screen width
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize); // Listen for screen resize

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup
    };
  }, []);

  useEffect(() => {
    const noSelectElements = document.querySelectorAll('.App');
    noSelectElements.forEach((element) => {
      element.style.webkitUserSelect = 'none';
      element.style.mozUserSelect = 'none';
      element.style.msUserSelect = 'none';
      element.style.userSelect = 'none';
    });
    console.log('testing log');

    // Check remembered login status but don't reset isLoggedIn automatically
    if (!isLoggedIn && localStorage.getItem('rememberMe') === 'true') {
      const rememberedEmail = localStorage.getItem('rememberedEmail');
      const rememberedPassword = localStorage.getItem('rememberedPassword');

      if (rememberedEmail && rememberedPassword) {
        setUsername(rememberedEmail);
      }
    }

  }, [location.pathname, isLoggedIn]);




  const handleLogin = (username) => {
    setIsLoggedIn(true);
    setUsername(username);
    localStorage.setItem('isLoggedIn', 'true');

  };

  const handleSignout = () => {
    // const domain = "https://us-east-1z0mtkhk91.auth.us-east-1.amazoncognito.com";
    // const clientId =process.env.REACT_APP_COGNITO_CLIENTID;
    // const logoutRedirectUri = "http://localhost:3000/logout"; // or your production URI

    if (localStorage.getItem('rememberMe') !== 'true') {
      localStorage.clear();
    } else {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('accessLevel');
      localStorage.removeItem('callAccess');
    }

    navigate('/');
    setIsLoggedIn(false);
    setUsername('');
    // Redirect to Cognito logout endpoint
    // window.location.href = `${domain}/logout?client_id=${clientId}&logout_uri=${logoutRedirectUri}`;
  };


  const ProtectedRoute = ({ children, allowedRoles }) => {
    const accessLevel = parseInt(localStorage.getItem('accessLevel'));

    return allowedRoles.includes(accessLevel)
      ? children
      : <Navigate to="/Datasets" />;
  };


  return (
    <div className={`App ${isLoggedIn ? 'logged-in' : ''}`}>

      {(isLoggedIn && callAccess === "true") && <GlobalCCP />}
      {isLoggedIn ?
        (
          <>
            <Navbar username={username} onSignout={handleSignout} />

            <div className="maincontent">
              <Routes>

                <>

                  <Route path="/Home" element={<Home />} />
                  <Route
                    path="/Logs"
                    element={
                      <ProtectedRoute allowedRoles={[1, 2]}>
                        <Logs />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/Users"
                    element={
                      <ProtectedRoute allowedRoles={[1]}>
                        <Users />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/Agencies" element={<Agencies />} />
                  <Route path="/add-agencyDetails" element={<AddAgency />} />
                  <Route path="/Ck_Dictionary" element={<Ck_Dictionary />} />
                  <Route path="/Add_CKDictionary" element={<Edit />} />
                  <Route path="/RequestSentDetails" element={<RequestSentDetails />} />
                  <Route path="/Datasets" element={<Datasets />} />
                  <Route path="/Ck_Schemas" element={<Ck_Schemas />} />
                  <Route path="/AddSchema" element={<AddSchema />} />
                  <Route path="/RequestDetail" element={<RequestDetail />} />
                  <Route path="/DocketDetails" element={<Docket_ListUI />} />
                  <Route path="/FileUploadPage" element={<FileUploadPage />} />
                  <Route path='/AgenctTicketHistory' element={<TicketHistory />} />
                  <Route path='/TicketDetails' element={<TicketDetails />} />
                  <Route path='/Call_History' element={<CallHistory />} />
                  <Route path='/AgencyDetailPage' element={<AgencyDetailPage />} />                 
                  <Route path='/requestopra' element={<RequestOpra />} />

                  {UserStatus !== 'EXTERNAL_PROVIDER' && (
                    <>
                      <Route path="/Settings" element={<Settings />}>
                        <Route path="Profile" element={<Profile />} />
                        <Route path="UpdatePassword" element={<UpdatePassword />} />
                        <Route path="DialPad" element={<DialPad />} />
                      </Route>
                    </>
                  )}


                </>
                <Route path="*" element={<Navigate to="/Datasets" />} />
              </Routes>
            </div>
          </>
        ) : (
          <Routes>
            <>
              <Route path="/" element={<SignIn onLogin={handleLogin} />} />
              <Route path="/SignUp" element={<SignUp onLogin={handleLogin} />} />
              <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/ValidateCode" element={<ValidateCode />} />
              <Route path="/VerifyEmail" element={<VerifyEmail />} />
              <Route path="/AccessDenied" element={<AccessDenied onSignout={handleSignout} />} />

            </>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )}

    </div>
  )
}

export default App;
